import * as Dialog from '@radix-ui/react-dialog';
import { Header, Title, CloseButton } from './title.styles';
import Icon from '@/components/uielements/icon';
import { useModalContext } from '@/components/uielements/modal/context';

export const ModalTitle = ({ children, ...otherProps }: React.HTMLProps<HTMLHeadingElement>) => {
  const { onCancel, dismissible } = useModalContext();

  return (
    <Header>
      <Title asChild>
        <h2 {...otherProps}>{children}</h2>
      </Title>
      {dismissible ? (
        <Dialog.Close asChild>
          <CloseButton onClick={onCancel}>
            <Icon.Close width="16" title="Dismiss" focusable={false} />
          </CloseButton>
        </Dialog.Close>
      ) : null}
    </Header>
  );
};
